var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"btn",staticClass:"back-to-top empha",attrs:{"title":"回到顶部"},on:{"click":_vm.totop}},[_vm._v(" TOP ")])}
var staticRenderFns = []

export { render, staticRenderFns }